import { CategoriesContent } from "@/components/categories-content"

export default function CategoriesPage() {
    return <CategoriesContent />
}
